import { FlexBox, Box, FileTile, FileTileThumbnail, ResponsiveImage, FileTileDeleteButton } from '@vp/swan';
import React from 'react';

const UploadAttachmentsPreview = ({ selectedFilePayload, isLoading, handleDeletePreview }) => {
  return /* @__PURE__ */ React.createElement(FlexBox, { gap: "4", justifyContent: "flex-start", alignItems: "center", flexWrap: "wrap" }, selectedFilePayload.length > 0 && selectedFilePayload.map((file) => {
    return /* @__PURE__ */ React.createElement(Box, { key: file.fileData.name }, /* @__PURE__ */ React.createElement(
      FileTile,
      {
        key: file.fileData.name,
        fileName: `${isLoading ? "uploading..." : file.fileData.name}`,
        accessibleTextForProgress: "100% loaded",
        accessibleTextForSpinner: "Waiting",
        skin: `${isLoading ? "queued" : "standard"}`,
        style: { maxWidth: "78px", maxHeight: "78px" }
      },
      /* @__PURE__ */ React.createElement(FileTileThumbnail, null, /* @__PURE__ */ React.createElement(ResponsiveImage, { src: file.previewUrl, alt: `` })),
      /* @__PURE__ */ React.createElement(FileTileDeleteButton, { accessibleText: "Delete file: my-file.png", onClick: () => handleDeletePreview(file.fileData.name) })
    ));
  }));
};

export { UploadAttachmentsPreview as default };
//# sourceMappingURL=src-components-UploadAttachments-UploadAttachmentsPreview.js.map
